<template>
  <div class="centerx con-exemple-prompt">
    <!-- <vs-prompt
      @cancel="cancalFunc"
      @accept="save"
      :active.sync="active"
      title="税率设置"
      accept-text="确定"
      cancel-text="取消"
    >
      <div class="con-exemple-prompt">
        <span>税率名称:</span><br />
        <vs-input
          placeholder="税率名称"
          v-model="name"
        />
      </div>
      <div class="con-exemple-prompt">
        <span>税率（%）:</span><br />
        <vs-input
          placeholder="税率"
          v-model="tax_rate"
        />
      </div>
    </vs-prompt> -->
    <vs-popup :title="popUpTitle" :active.sync="taxPopUpActive">
      <div class>
        <div class="vx-row ml-4 mb-4">
          <div class="vx-col w-full">
            <label class="mb-5">税率名称</label>
            <vs-input placeholder="税率名称" v-model="name" />
          </div>
        </div>
        <div class="vx-row ml-4 mb-4">
          <div class="vx-col w-full">
            <label class="mb-5">税率（%）:</label>
            <vs-input placeholder="税率" v-model="tax_rate" />
          </div>
        </div>

        <div class="flex mt-4 justify-end">
          <vs-button class="mr-3" @click="save">确定</vs-button>
          <vs-button type="border" @click="cancalFunc">关闭</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import repoTax from '@/repo/tax.js'
export default {
  data() {
    return {
      popUpTitle: '税率设置',
      taxPopUpActive: false,
      index_id: '',

      name: '',
      tax_rate: '',
    }
  },
  mounted() {},
  methods: {
    fetch: function (row) {
      let that = this
      repoTax.detail(row.id, (error, resp) => {
        if (resp.code == 0) {
          that.name = resp.data.name
          that.tax_rate = resp.data.tax_rate
        } else {
          that.$vs.notify({
            color: 'danger',
            title: '错误提示',
            text: resp.msg,
          })
        }
      })
    },

    openDialog: function (row) {
      this.taxPopUpActive = true
      if (row) {
        this.index_id = row.id
        this.fetch(row)
      }
    },

    save: function () {
      if (!this.name.trim()) {
        this.$vs.notify({
          color: 'danger',
          title: '错误提示',
          text: '请输入税率名',
        })
        return
      }
      let that = this
      let params = {
        name: this.name,
        tax_rate: this.tax_rate,
      }

      if (this.index_id) {
        repoTax.edit(this.index_id, params, (error, resp) => {
          if (resp.code == 0) {
            that.$vs.notify({
              color: 'success',
              title: '操作提示',
              text: resp.msg,
            })
            that.name = ''
            that.tax_rate = ''
            that.$emit('getReBackList')
            that.taxPopUpActive = false
          } else {
            that.$vs.notify({
              color: 'danger',
              title: '错误提示',
              text: resp.msg,
            })
          }
        })
      } else {
        repoTax.create(params, (error, resp) => {
          if (resp.code == 0) {
            that.$vs.notify({
              color: 'success',
              title: '操作提示',
              text: resp.msg,
            })
            that.name = ''
            that.tax_rate = ''
            that.$emit('getReBackList')
            that.taxPopUpActive = false
          } else {
            that.$vs.notify({
              color: 'danger',
              title: '错误提示',
              text: resp.msg,
            })
          }
        })
      }
    },

    cancalFunc: function () {
      this.taxPopUpActive = false
      this.name = ''
      this.tax_rate = ''
    },
  },
}
</script>

<style lang="scss"></style>
